<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>New Applicant ID</h1>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="Emp Code"
            v-model="model.empCode"
            :class="classPadding"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="Name"
            v-model="model.empName"
            :class="classPadding"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
          <v-btn outlined text @click.prevent="search">Search</v-btn>
        </v-col>
      </v-row>
      <v-data-table :items="items" :headers="headers" v-if="items.length > 0">
        <template v-slot:item.actions="{ item }">
          <v-btn icon text @click.stop="edit(item)" v-if="userAccess.edit >= 1">
            <v-icon color="info">mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-container>
    <v-dialog v-model="editDialog" width="500">
      <v-card>
        <v-card-title>
          <span class="headline">Edit</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
              <v-text-field
                label="Employee ID"
                v-model="editModel.empCode"
                :class="classPadding"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
              <v-text-field
                label="New Employee ID"
                v-model="employeeID"
                :class="classPadding"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.prevent="editDialog = false" color="error" text
            >Close</v-btn
          >
          <v-btn @click="save" color="success" text v-if="userAccess.add >= 1"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import userAccessMixin from "../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/manpower";
// import { isNullOrUndefined } from "../../../validation/validation";
export default {
  metaInfo: {
    title: "New Applicant ID",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  data: () => ({
    classPadding: "my-0 py-0",
    model: {
      empCode: "",
      empName: ""
    },
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Employee ID",
        value: "empCode",
        sortable: false
      },
      {
        text: "New ID Number",
        value: "newID",
        sortable: false
      },
      {
        text: "Name",
        value: "fullName",
        sortable: false
      }
    ],
    editDialog: false,
    employeeID: null,
    editModel: {}
  }),
  methods: {
    search() {
      //let { empCode, empName } = this.model;

      this.$axios
        .post(`${API_ENDPOINT}/applicant`, this.model)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    edit(item) {
      this.editDialog = true;
      this.editModel = Object.assign({}, item);
    },
    save() {
      let { empCode } = this.editModel;
      this.$axios
        .post(`${API_ENDPOINT}/newempcode`, {
          empCode,
          newEmpCode: this.employeeID
        })
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.editModel = {};
          this.employeeID = null;
          this.editDialog = false;
          this.search();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    }
  },
  created() {
    this.search();
    this.getUserAccessRights("MPAID");
  }
};
</script>